export const SETTINGS_KEY = 'SETTINGS';
export const defaultSettings = {
  hideOthersChat: false,
  gameSounds: true,
  backgroundMusic: true,
  videoStreamSound: true,
};
